import styled from 'styled-components';
import { Progress } from 'antd';

export const ProgressWrapper = styled(Progress)`
	.ant-progress-bg {
		background-color: ${({ theme }) => theme.colors.primary};
	}
`;
